module.exports = __webpack_public_path__ + "img/ic_checkbox_marked_airlead.ae64cb9c.svg";